export const BARLOW = "Barlow";
export const MONUMENT = "Monument";

export const BOWLBY = 'Bowlby';

export const KLIMA = 'Klima';